// this value should match the version in package.json
export var HubSdkVersion = '2.0.0';
export var SdkMessageTypes = {
    appInitialization: {
        appLoaded: 'appInitialization.appLoaded',
        expectedFailure: 'appInitialization.expectedFailure',
        failure: 'appInitialization.failure',
        success: 'appInitialization.success',
    },
    appInstallDialog: {
        openAppInstallDialog: 'appInstallDialog.openAppInstallDialog',
    },
    authentication: {
        getAuthToken: 'authentication.getAuthToken',
        getUser: 'authentication.getUser',
        authenticate: 'authentication.authenticate',
        notifySuccess: 'authentication.authenticate.success',
        notifyFailure: 'authentication.authenticate.failure',
    },
    appEntity: {
        selectAppEntity: 'appEntity.selectAppEntity',
    },
    barCode: {
        scanBarCode: 'media.scanBarCode',
    },
    calendar: {
        composeMeeting: 'calendar.composeMeeting',
        openCalendarItem: 'calendar.openCalendarItem',
    },
    call: {
        startCall: 'call.startCall',
    },
    chat: {
        openChat: 'chat.openChat',
    },
    conversations: {
        openConversation: 'conversations.openConversation',
        closeConversation: 'conversations.closeConversation',
        getChatMembers: 'getChatMembers',
    },
    dialogs: {
        open: 'tasks.startTask',
        submit: 'tasks.completeTask',
        update: {
            resize: 'tasks.updateTask',
        },
    },
    files: {
        addCloudStorageFolder: 'files.addCloudStorageFolder',
        copyMoveFiles: 'files.copyMoveFiles',
        deleteCloudStorageFolder: 'files.deleteCloudStorageFolder',
        getCloudStorageFolders: 'files.getCloudStorageFolders',
        openFilePreview: 'openFilePreview',
        getExternalProviders: 'files.getExternalProviders',
        openCloudStorageFile: 'files.openCloudStorageFile',
        getCloudStorageFolderContents: 'files.getCloudStorageFolderContents',
    },
    getContext: 'getContext',
    initialize: 'initialize',
    location: {
        getCurrentLocation: 'location.getLocation',
        map: {
            showLocation: 'location.showLocation',
        },
    },
    interactive: {
        getFluidTenantInfo: 'interactive.getFluidTenantInfo',
        getFluidToken: 'interactive.getFluidToken',
        getFluidContainerId: 'interactive.getFluidContainerId',
        setFluidContainerId: 'interactive.setFluidContainerId',
        getNtpTime: 'interactive.getNtpTime',
        registerClientId: 'interactive.registerClientId',
        getClientRoles: 'interactive.getClientRoles',
        getClientInfo: 'interactive.getClientInfo',
    },
    links: {
        openLink: 'executeDeepLink',
    },
    logs: {
        handleAppLog: 'log.receive',
    },
    mail: {
        composeMail: 'mail.composeMail',
        openMailItem: 'mail.openMailItem',
    },
    media: {
        captureImage: 'captureImage',
        getMedia: 'getMedia',
        selectMedia: 'selectMedia',
        viewImages: 'viewImages',
    },
    meeting: {
        getAppContentStageSharingCapabilities: 'meeting.getAppContentStageSharingCapabilities',
        getAppContentStageSharingState: 'meeting.getAppContentStageSharingState',
        getAuthenticationTokenForAnonymousUser: 'meeting.getAuthenticationTokenForAnonymousUser',
        getIncomingClientAudioState: 'getIncomingClientAudioState',
        getLiveStreamState: 'meeting.getLiveStreamState',
        meetingReactionReceived: 'meeting.meetingReactionReceived',
        getMeetingDetails: 'meeting.getMeetingDetails',
        appShareButton: {
            setOptions: 'meeting.appShareButton.setOptions',
        },
        raiseHandStateChanged: 'meeting.raiseHandStateChanged',
        requestStartLiveStreaming: 'meeting.requestStartLiveStreaming',
        requestStopLiveStreaming: 'meeting.requestStopLiveStreaming',
        shareAppContentToStage: 'meeting.shareAppContentToStage',
        speakingStateChanged: 'meeting.speakingStateChanged',
        stopSharingAppContentToStage: 'meeting.stopSharingAppContentToStage',
        toggleIncomingClientAudio: 'toggleIncomingClientAudio',
        requestAppAudioHandling: 'meeting.requestAppAudioHandling',
        updateMicState: 'meeting.updateMicState',
        micStateChanged: 'meeting.micStateChanged',
    },
    meetingRoom: {
        getPairedMeetingRoomInfo: 'meetingRoom.getPairedMeetingRoomInfo',
        sendCommandToPairedMeetingRoom: 'meetingRoom.sendCommandToPairedMeetingRoom',
    },
    monetization: {
        openPurchaseExperience: 'monetization.openPurchaseExperience',
    },
    notifications: {
        showNotification: 'notifications.showNotification',
    },
    pages: {
        getConfig: 'settings.getSettings',
        navigateCrossDomain: 'navigateCrossDomain',
        navigateToApp: 'pages.navigateToApp',
        returnFocus: 'returnFocus',
        setCurrentFrame: 'setFrameContext',
        shareDeepLink: 'shareDeepLink',
        backStack: {
            navigateBack: 'navigateBack',
        },
        currentApp: {
            navigateTo: 'pages.currentApp.navigateTo',
            navigateToDefaultPage: 'pages.currentApp.navigateToDefaultPage',
        },
        tabs: {
            getTabInstances: 'getTabInstances',
            getMruTabInstances: 'getMruTabInstances',
            navigateToTab: 'navigateToTab',
        },
        config: {
            setConfig: 'settings.setSettings',
            setValidityState: 'settings.setValidityState',
            save: {
                success: 'settings.save.success',
                failure: 'settings.save.failure',
            },
            remove: {
                success: 'settings.remove.success',
                failure: 'settings.remove.failure',
            },
        },
        fullTrust: {
            enterFullscreen: 'enterFullscreen',
            exitFullscreen: 'exitFullscreen',
        },
    },
    people: {
        selectPeople: 'people.selectPeople',
    },
    permissions: {
        storageService: {
            getPermissionStatus: 'permissions.has',
        },
        requestUserConsentForPermission: 'permissions.request',
    },
    profile: {
        showProfile: 'profile.showProfile',
    },
    remoteCamera: {
        getCapableParticipants: 'remoteCamera.getCapableParticipants',
        requestControl: 'remoteCamera.requestControl',
        sendControlCommand: 'remoteCamera.sendControlCommand',
        terminateSession: 'remoteCamera.terminateSession',
    },
    readyToUnload: 'readyToUnload',
    registerHandler: 'registerHandler',
    search: {
        unregister: 'search.unregister',
    },
    sharing: {
        shareWebContent: 'sharing.shareWebContent',
    },
    stageView: {
        open: 'stageView.open',
    },
    teams: {
        getTeamChannels: 'teams.getTeamChannels',
        refreshSiteUrl: 'teams.refreshSiteUrl',
        fullTrust: {
            getConfigSetting: 'getConfigSetting',
            joinedTeams: {
                getUserJoinedTeams: 'getUserJoinedTeams',
            },
        },
    },
};
export var FailedReason;
(function (FailedReason) {
    // External Failure reasons passed from app
    FailedReason["AuthFailed"] = "AuthFailed";
    FailedReason["Timeout"] = "Timeout";
    FailedReason["Other"] = "Other";
    // Internal failure reasons
    // AppInitTimeout is the failure reason when initialization call to the app times out
    FailedReason["AppInitTimeout"] = "AppInitTimeout";
    FailedReason["Validation"] = "Validation";
    FailedReason["Validation_InvalidDomains"] = "Validation_InvalidDomains";
})(FailedReason || (FailedReason = {}));
export var ExpectedFailureReason;
(function (ExpectedFailureReason) {
    ExpectedFailureReason["PermissionError"] = "PermissionError";
    ExpectedFailureReason["NotFound"] = "NotFound";
    ExpectedFailureReason["Throttling"] = "Throttling";
    ExpectedFailureReason["Offline"] = "Offline";
    ExpectedFailureReason["Other"] = "Other";
})(ExpectedFailureReason || (ExpectedFailureReason = {}));
export var appUrlResource = {
    resourceDomainParameter: '{resourceDomain}',
    validResourcePattern: '^((https|api)://{resourceDomain}([:/].*)?)$',
};
// The regex translates to: "you can have as many leading wildcard segments as necessary,
// with each wildcard segment having only a single wildcard in each segment. No wildcard segments may follow any non-wildcard segments."
// Proper format is where:
// 1. Wildcard (‘*’) is the only character in a segment if a wildcard is present.
// 2. If using a wildcard, there may be no segments preceding it that do not contain wildcards.
// e.g., “*.*.domain.com” is valid but 'foo.*.myteam.domain.com' is not valid
// Please check out our official docs here: https://learn.microsoft.com/en-us/microsoftteams/platform/resources/schema/manifest-schema?view=msteams-client-js-latest#validdomains
export var properWildcardDomainRegex = /^(\*\.)*[^*]+$/i;
// The valid domains we receive in the app definition use asterisks to represent wildcards for valid subdomains. However, our usage of JavaScript regex
// uses a different syntax, so we use this regex as the wildcard replacement string for any asterisks found in the valid domains list.
// This regex translates to "one or more characters that are not '/', '^'. or '.'""
export var wildcardReplacementRegexStr = '[^/^.]+';
export var fullPermissionApps = ['com.example.microsoftteamstabs.test', 'com.example.metaostestapp.test'];
export var invalidUrlErrorMessage = 'Url is invalid';
export var invalidDomainErrorMessage = "There is at least one improperly formatted domain in the provided app definition's validDomains field";
// Here are some common invalid URLs that can be used for tests checking URL validity.
// This is by no means an exhaustive list, but it offers some off the shelf URLs to use for those not looking to design their own malicious URL.
// Feel free to add to this list if you know off/find any more "sneaky" URLs
export var invalidUrls = {
    notAUrl: 'invalid-url',
    fakeLoginCredentials: 'https://benign.com:x@malicious.com',
    javascriptProtocol: 'javascript://maliciouspayload',
    // eslint-disable-next-line @microsoft/sdl/no-insecure-url
    httpProtocol: 'http://foo.com',
    rtmpProtocol: 'rtmp://foo.com',
    rtmpsProtocol: 'rtmps://foo.com',
    endsWithMatching: 'maliciousbenign.com',
    missingExtension: 'https://foo',
    nonStandardPort: 'https://foo.com:8800',
    invalidEncodedUrl: 'https%3A%2F%2Fwww.evil.com%2Fhello',
    encodedUrl: 'https://evil%2Ecom#.testtab.com',
    multipleWildcardsWithinSegment: 'https://*b*.microsoft.com',
    moreThanWildcardInWildcardSegment: 'https://test.*microsoft.com',
    nonLeadingWildcard: 'https://foo.*.my.microsoft.com',
};
//# sourceMappingURL=constants.js.map